import(/* webpackMode: "eager" */ "/vercel/path0/src/app/portfolio-case-studies/page.tsx");
